// Copyright (c) Docugami, Inc. All rights reserved.

import { createGlobalStyle } from "styled-components";

export const AgGridContainerStyle = {
    width: '100%',
    height: '100%',
    overflow: 'auto',
    '--ag-borders': 'none',
    '--ag-row-border-style': 'solid',
    '--ag-row-border-width': '1px',
    '--ag-row-border-color': 'rgb(150, 150, 200)',
    '--ag-cell-horizontal-border': 'solid rgb(150, 150, 200)',
} as React.CSSProperties;

export const AgGridLibraryStyleAlterations = createGlobalStyle`
  .ag-header-cell-comp-wrapper {
    border-right: 1px solid rgb(150, 150, 200) !important;
    border-top: 1px solid rgb(150, 150, 200) !important;
  }

  .ag-body-horizontal-scroll {
    overflow-x: auto !important;
  }
`;
